import { render, staticRenderFns } from "./HomeProducts.vue?vue&type=template&id=7dda727a&"
import script from "./HomeProducts.vue?vue&type=script&lang=js&"
export * from "./HomeProducts.vue?vue&type=script&lang=js&"
import style0 from "./HomeProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports